import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.white };
  padding: 20px; 
  border-radius: 5px;
  width: 100%;  
  max-width: 1200px;
  margin: 0 auto;
`

export const HeaderWrapper = styled.div`
  margin: 20px 0;    
  display: grid;
  grid-template-columns: 100px 2fr 1fr 1fr;    
  background-color: ${({ theme }) => theme.color.lightGrey};
  border-radius: 5px;
`

export const Logo = styled.div`    
  padding: 15px;  
  height: 100%;
  img {    
    max-width: 100%;
    max-height: 100%;
  }
`

export const TitleWrapper = styled.div`  
  margin: auto 0;    
  padding-left: 10px;
  h1 {
    margin: 0;
  }
`

export const ResortIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;  
`

export const Alt = styled.h3`
  margin-top: 20px;  
`

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 9fr 1fr;
  grid-template-rows: minmax(100px, auto);
  gap: 20px;  
  line-height: 1.8;  
  ${({ theme }) => theme.mediaQuery.tablet} {
    grid-template-columns: 1fr 350px;
  }

`

export const ResortView = styled.img`
  grid-column: 2 / 3;
  grid-row: 1;
  width: 100%;  
`

export const ResortImage = styled.img`
  grid-column: 2 / 3;
  grid-row: 2;
  width: 100%;     
`

export const ResortMap = styled.iframe`
  border-radius: 10px;
  border: 0;
`

export const Content = styled.div`
  grid-column: 1 / 2;
  grid-row: 1 / 4;     
`

export const TrailsBar = styled.div`
  display: flex;
  svg {
    width: 80px;
    height: 80px;    
  }
`

export const ResortInfoEntry = styled.div`
  svg {
    margin-right: 8px;
  }
`
